// extracted by mini-css-extract-plugin
export default {"fullQuizContainer":"FullQuizCreator_fullQuizContainer__yyMCf"};